import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { AddIcon, DeleteIcon, EditIcon, FoldDown, FoldRight } from "../../Assets/Icons";

const CategoryItem = ({ level, key, category, tagModal, openModal, openEditModal, openDeleteModal, tagEditModal }) => {
  const [showChildren, setShowChildren] = useState(false);

  return (
    <>
      <div className="cate-list" key={key}>
        <div className="parent-child">
          <div className="child">
            <div className="parent">
              <span className="cate-action">
                {category.children.length > 0 && (
                  <button className="fold" onClick={() => setShowChildren(!showChildren)}>
                    {showChildren ? <FoldDown /> : <FoldRight />}
                  </button>
                )}
                {category.name}
              </span>
              <span className=" action-item cate-action   ">
                <button className="action-btn " onClick={() => tagModal("", category.id)}>
                  <AddIcon /> Tag List
                </button>
                <button className="action-btn " onClick={() => openModal("sub.category", category.id)}>
                  <AddIcon /> Category
                </button>

                <button
                  onClick={() =>
                    openEditModal(
                      level === 1 ? "category" : "sub.category",
                      category.name,
                      category.id,
                      category.parentId
                    )
                 
                  }
                >
                  <EditIcon />
                </button>

                <button onClick={() => openDeleteModal(category.id)}>
                  <DeleteIcon />
                </button>
              </span>
            </div>

            {showChildren && category.children.length > 0 && (
              <div className="children">
                {category.children.map((child, index) => (
                  <CategoryItem
                    level={level + 1}
                    key={child.id}
                    category={child}
                    tagModal={tagModal}
                    openModal={openModal}
                    openEditModal={openEditModal}
                    openDeleteModal={openDeleteModal}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryItem;
